import useFleetStore from "../stores/useFleetStore";

const OfficeMarquee = () => {
  const drones = useFleetStore((state) => state.drones);

  // Single set of messages
  const MessageSet = () => (
    <>
      <span className="px-8 text-on-surface-variant whitespace-nowrap">
        Welcome to Firefly HQ!!
      </span>
      <span className="text-gray-700 px-2">•</span>
      <span className="px-8 text-on-surface-variant whitespace-nowrap">
        Total Drones: <span className="text-primary font-semibold">{drones.length}</span>
      </span>
      <span className="text-gray-700 px-2">•</span>
      <span className="px-8 text-primary font-bold whitespace-nowrap tracking-wide">
        DO DRONE SHOWS
      </span>
      <span className="text-gray-700 px-2">•</span>
    </>
  );

  return (
    <div className="relative overflow-hidden rounded-lg bg-gradient-to-r from-[#1a1a1a] via-[#2a2a2a] to-[#1a1a1a] border border-gray-800">
      {/* Gradient fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-[#1a1a1a] to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-[#1a1a1a] to-transparent z-10 pointer-events-none" />

      {/*
        Marquee structure: Two halves, each at least 100vw wide.
        Animation moves -50%, which shifts exactly one half out and the identical second half in.
      */}
      <div className="marquee-track flex py-2.5 items-center" style={{ minWidth: '200vw' }}>
        {/* First half - must be at least 100vw */}
        <div className="flex items-center shrink-0" style={{ minWidth: '100vw' }}>
          {[...Array(6)].map((_, idx) => (
            <div key={idx} className="flex items-center shrink-0">
              <MessageSet />
            </div>
          ))}
        </div>
        {/* Second half - identical to first, also at least 100vw */}
        <div className="flex items-center shrink-0" style={{ minWidth: '100vw' }}>
          {[...Array(6)].map((_, idx) => (
            <div key={idx} className="flex items-center shrink-0">
              <MessageSet />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OfficeMarquee;
